import { NavLink } from "react-router-dom";
import {
  BriefcaseBusiness,
  FileText,
  FolderKanban,
  Inbox,
  LayoutDashboard,
  Users,
} from "lucide-react";
import { cn } from "@/utils/format";

const items: Array<{
  to: string;
  label: string;
  icon: typeof LayoutDashboard;
  end?: boolean;
}> = [
  { to: "/", label: "Home", icon: LayoutDashboard, end: true },
  { to: "/business-development/crm/leads", label: "Leads", icon: BriefcaseBusiness },
  { to: "/business-development/crm/clients", label: "Clients", icon: Users },
  { to: "/business-development/crm/projects", label: "Projects", icon: FolderKanban },
  { to: "/business-development/inquiries", label: "Inbox", icon: Inbox },
  { to: "/business-development/applications", label: "Apps", icon: FileText },
];

/**
 * Phone-only primary destinations. Desktop sidebar unchanged.
 * Shown at ≤768px via CSS (.mobile-bottom-nav).
 */
export function MobileBottomNav() {
  return (
    <nav className="mobile-bottom-nav" aria-label="Primary">
      {items.map(({ to, label, icon: Icon, end }) => (
        <NavLink
          key={to}
          to={to}
          end={Boolean(end)}
          className={({ isActive }) =>
            cn("mobile-bottom-nav__item", isActive && "mobile-bottom-nav__item--active")
          }
        >
          <Icon size={20} strokeWidth={2} aria-hidden />
          <span>{label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
